import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function allFetchData() {
  // Use toast
  const toast = useToast()

  const refDataTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'name', label: 'nombre', sortable: true },
    {
      key: 'device.name',
      label: 'dispositivo',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'threshold',
      label: 'umbral',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'enabled',
      label: 'habilitado',
      sortable: false,
      class: 'no-sort'
    },
    {
      key: 'actions',
      label: 'acciones',
      align: 'center',
      sortable: false,
      class: 'no-sort'
    },
  ]
  const perPage = ref(10)
  const totalData = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const loading = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refDataTable.value ? refDataTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalData.value,
    }
  })

  const refetchData = () => {
    refDataTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const msgError = error => {
    let msg = 'Error al procesar los datos'
    switch (error) {
      case 409:
        msg = 'Ya existe un registro con los mismos datos'
        break
      default:
        break
    }
    toast({
      component: ToastificationContent,
      props: {
        title: msg,
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
  }

  const msgSuccess = () => {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Operación realizada con éxito',
        icon: 'CheckIcon',
        variant: 'success',
      },
    })
  }

  const fetchData = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertConf/fetchAlerts', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        const { rows, count } = response.data

        callback(rows)
        totalData.value = count
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchAdd = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertConf/addAlert', { alert: ctx })
      .then(response => {
        const alert = response.data
        if (refDataTable.value) {
          refDataTable.value.localItems.push(alert)
        }
        totalData.value += 1
        msgSuccess()
        loading.value = false
        callback(alert)
      })
      .catch(error => {
        console.log(error)
        msgError(error.response.status)
        loading.value = false
      })
  }

  const fetchUpdate = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertConf/updateAlert', { id: ctx.id, alert: ctx })
      .then(response => {
        const alert = response.data
        const index = refDataTable.value.localItems.findIndex(item => item.id === alert.id)
        refDataTable.value.localItems.splice(index, 1, alert)
        msgSuccess()
        loading.value = false
        callback(alert)
      })
      .catch(error => {
        console.log(error)
        msgError(error.response.status)
        loading.value = false
      })
  }

  const fetchDelete = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertConf/deleteAlert', { id: ctx })
      .then(response => {
        const alert = response.data
        const index = refDataTable.value.localItems.findIndex(item => item.id === alert.id)
        refDataTable.value.localItems.splice(index, 1)
        msgSuccess()
        callback(alert)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  const fetchExport = (ctx, callback) => {
    loading.value = true
    store
      .dispatch('alertConf/exportAlertConfig', { ctx })
      .then(response => {
        msgSuccess()
        callback(response.data)
        loading.value = false
      })
      .catch(error => {
        console.log(error)
        msgError()
        loading.value = false
      })
  }

  return {
    fetchData,
    fetchAdd,
    fetchUpdate,
    fetchDelete,
    fetchExport,
    tableColumns,
    perPage,
    currentPage,
    totalData,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refDataTable,
    loading,
    refetchData,
  }
}
